import getOr from 'lodash/fp/getOr';

export const gatherFormData = (formKey, form) => {
  const formRole = getformRole(formKey, form);
  const customerAssignmentData = getCustomerAssignmentData(formKey, form);

  return {
    formRole,
    customerAssignmentData,
  };
};

const getformRole = (formKey, form) => {
  const rolesField = getOr([], `${formKey}.data.roles`, form);
  return rolesField[0] || '';
};

const getCustomerAssignmentData = (formKey, form) => {
  return getOr({}, `${formKey}.data.care_navigator_customer_assignment`, form);
};
